import { Attributes, Misc, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class SecurityHoldingSearchCriteria extends ValueObject {

    @Rules.Required()
    public staticServiceProviderFileGroupingID: number = 0;

    public serviceProviderGroupingName: string | null = null;

    public rawAccountNumber: string = "";

    public clientAccountNumber: string = "";

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public clientAccountDescription: string = "";

    public instrument: string = "";

    public instrumentID: number | null = null;

    public groupingDescription: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public date: Date | null = null;
}